import { Divider } from "@chakra-ui/react";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";

export function ContentDivider() {
  const isMobile = useMobileBreakpoint();

  return (
    <Divider
      height="1px"
      width="100%"
      background="transparent.white.20"
      mb={isMobile ? "24px" : "40px"}
    />
  );
}
